'use client';

import React from 'react';
import Link from 'next/link';
import NavBar from '@/components/NavBar';

export default function ExclusivePage() {
  return (
    <div className="min-h-screen bg-surface-primary font-condensed">
      {/* Header */}
      <NavBar
        activePage="exclusive"
        hasTicker={false}
        rightSlot={
          <Link
            href="/"
            className="flex items-center gap-1.5 text-text-secondary hover:text-text-primary transition-colors text-sm font-bold uppercase tracking-wide min-h-[44px] px-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            <span className="hidden sm:inline">Back</span>
          </Link>
        }
      />
      <main className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
        {/* Page Title */}
        <div className="flex items-baseline gap-3 border-b border-stroke-primary pb-4 mb-8">
          <h1 className="text-text-primary text-3xl md:text-4xl font-normal">VIDDSTAR</h1>
          <span className="text-brand-red font-bold text-3xl md:text-4xl">EXCLUSIVE</span>
          <span className="ml-2 bg-surface-tertiary text-brand-red text-xs font-bold uppercase px-2 py-1 border border-brand-red rounded-[2px]">★ Original</span>
        </div>

        {/* Description */}
        <div className="mb-10 max-w-2xl">
          <p className="text-text-secondary text-lg leading-relaxed">
            ViddStar original content — produced, curated, and delivered exclusively here. No reposts. No recycled clips. Just raw originals.
          </p>
        </div>

        {/* Coming Soon State */}
        <div className="flex flex-col items-center justify-center py-24 border border-stroke-primary bg-surface-secondary">
          <div className="w-20 h-20 bg-surface-tertiary rounded-full flex items-center justify-center mb-6">
            <svg className="w-10 h-10 text-brand-red" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
            </svg>
          </div>
          <h2 className="text-text-primary text-2xl font-bold mb-2">Coming Soon</h2>
          <p className="text-text-secondary text-base mb-6 text-center max-w-md">
            ViddStar Exclusive is in production. Original content drops are coming — be the first to know.
          </p>
          <Link href="/" className="btn-primary px-6 py-2.5">
            Watch Videos on ViddStarTV
          </Link>
        </div>

        {/* Brand Sections */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { label: 'ViddStarTV', desc: 'Main videos platform', href: '/', icon: 'M15 10l4.553-2.069A1 1 0 0121 8.87v6.26a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' },
            { label: 'ViddStar Clips', desc: 'Short viral content', href: '/clips', icon: 'M7 4v16M17 4v16M3 8h4m10 0h4M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z' },
            { label: 'ViddStar News', desc: 'Commentary & blogs', href: '/news', icon: 'M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z' },
          ]?.map(item => (
            <Link key={item?.label} href={item?.href} className="group border border-stroke-primary hover:border-brand-red transition-colors duration-200 p-5 bg-surface-secondary flex items-start gap-4">
              <div className="w-10 h-10 bg-surface-tertiary rounded-[4px] flex items-center justify-center flex-shrink-0 group-hover:bg-brand-red transition-colors duration-200">
                <svg className="w-5 h-5 text-text-secondary group-hover:text-white transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={item?.icon} />
                </svg>
              </div>
              <div>
                <h3 className="text-text-primary font-bold text-sm uppercase tracking-wide group-hover:text-brand-red transition-colors duration-150">{item?.label}</h3>
                <p className="text-text-muted text-xs mt-0.5">{item?.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </main>
      <footer className="border-t border-stroke-primary bg-surface-secondary mt-12">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-text-muted text-xs">&copy; 2024 ViddStar. All rights reserved.</p>
          <Link href="/" className="text-text-muted hover:text-brand-red text-xs transition-colors">← Back to ViddStarTV</Link>
        </div>
      </footer>
    </div>
  );
}
